<template>
  <section
    ref="root"
    class="last-comment"
    @click="onClick"
  >
    <span
      ref="body"
      class="body"
      :title="body"
    >
      {{ body ?? '--' }}
    </span>

    <CommentsButton
      ref="commentsButton"
      :entity="entity"
      :entity-type-name="entityTypeName"
    />
  </section>
</template>

<style lang="scss" src="./LastComment.scss"/>

<script lang="ts">
import BaseEntity from '@/core/misc/BaseEntity';

/**
 * Последний комментарий сущности + облачко комментариев.
 * Рассчитан на ячейку VDataGridV2: растягивается на всю ячейку (компенсирует её паддинг),
 * клик по любому месту ячейки открывает комментарии.
 */
export default defineComponent({
  name: 'LastComment',

  props: {
    /** Тип сущности на бэке (например 'demandV2', 'order') */
    entityTypeName: {
      type:     String,
      required: true,
    },
    entity: {
      type:     Object as PropType<BaseEntity>,
      required: true,
    },
  },

  computed: {
    body(): string | null {
      return this.entity.commentsStatus?.lastComment?.body ?? null;
    },
  },

  methods: {
    /**
     * Открываем комментарии только по клику в саму ячейку или по тексту.
     * Клик по облачку CommentsButton обрабатывает сам, а клики из его попапа
     * (если он не телепортирован) сюда тоже всплывают — их не трогаем,
     * иначе закрытие попапа тут же откроет его снова.
     */
    onClick(event: MouseEvent): void {
      const target = event.target as Node;

      if (target === this.$refs.root || (this.$refs.body as HTMLElement).contains(target) === true) {
        (this.$refs.commentsButton as { open(): void }).open();
      }
    },
  },
});
</script>